export const serviciosTopografia = [
    {
        slug: "plano-topografico",
        titulo: "Plano Topográfico",
        desc: "Representación detallada del relieve del terreno.",
        descripcionLarga: "Estudio detallado de las características físicas del terreno, incluyendo variaciones de nivel, pendientes y elementos naturales o artificiales existentes.",
        precio: "Desde S/ 400",
        img: "https://inmocredex.com/wp-content/themes/yootheme/cache/55/topografico-558f92c2.jpeg",
        entidades: ["Municipalidades", "Empresas Constructoras", "Ministerio de Vivienda"],
        usos: ["Diseño de proyectos arquitectónicos", "Cálculo de movimiento de tierras", "Estudios de drenaje y alcantarillado"],
        entregables: ["Plano de curvas de nivel (DWG/PDF)", "Informe técnico de campo", "Panel fotográfico"],
        tiempoEstimado: "2 a 4 días hábiles"
    },
    {
        slug: "plano-perimetrico",
        titulo: "Plano Perimétrico y de Ubicación",
        desc: "Delimitación precisa de los linderos del terreno.",
        descripcionLarga: "Documento técnico que establece los límites exactos, ángulos internos y coordenadas UTM del predio, esencial para la seguridad jurídica de la propiedad.",
        precio: "Desde S/ 400",
        img: "https://dn721908.ca.archive.org/0/items/cpmm-pla-15-pdf/CPMM-PLA-15%20PDF.jpg",
        entidades: ["SUNARP", "Notarías", "Municipalidades (Catastro)"],
        usos: ["Inscripción de predios", "Compraventa de inmuebles", "Rectificación de áreas y linderos"],
        entregables: ["Plano Perimétrico Georreferenciado", "Plano de Ubicación y Localización", "Memoria Descriptiva visada"],
        tiempoEstimado: "3 días hábiles"
    },
    {
        slug: "subdivision",
        titulo: "Subdivisión de Terreno",
        desc: "División legal del predio en lotes independientes.",
        descripcionLarga: "Gestión integral para fraccionar un terreno matriz en dos o más lotes, cumpliendo con los parámetros urbanísticos de la zona.",
        precio: "Desde S/ 400",
        img: "https://imgv2-1-f.scribdassets.com/img/document/471433311/original/ba90f5fbe4/1?v=1",
        entidades: ["Municipalidad Distrital", "SUNARP"],
        usos: ["Venta de lotes por separado", "Herencias y reparticiones familiares", "Independización de unidades inmobiliarias"],
        entregables: ["Expediente técnico de subdivisión", "Planos de lotización", "Resolución municipal (gestión)"],
        tiempoEstimado: "15 a 30 días (dependiendo de la municipalidad)"
    },
    {
        slug: "fotogrametria",
        titulo: "Levantamiento Fotogramétrico (Dron)",
        desc: "Uso de drones para modelado del terreno.",
        descripcionLarga: "Mapeo aéreo de alta precisión que permite obtener ortofotos y modelos 3D de grandes extensiones de terreno en poco tiempo.",
        precio: "Desde S/ 800",
        img: "https://arquidron.com/wp-content/uploads/2020/01/topografia-com-drones.jpg",
        entidades: ["Ministerio de Agricultura", "Empresas Mineras", "Inmobiliarias"],
        usos: ["Catastro rural", "Control de avance de obras masivas", "Modelado 3D para marketing inmobiliario"],
        entregables: ["Ortofoto de alta resolución", "Modelo Digital de Elevación (MDE)", "Nube de puntos"],
        tiempoEstimado: "2 a 3 días hábiles"
    },
    {
        slug: "replanteo",
        titulo: "Replanteo de Lotes y Ejes",
        desc: "Marcación en campo del diseño del lote.",
        descripcionLarga: "Traslado preciso de las medidas del plano al terreno real para asegurar que la construcción se edifique exactamente donde corresponde.",
        precio: "Desde S/ 800",
        img: "https://perfiltopografia.es/wp-content/uploads/2021/07/replanteo-topografico.jpg",
        entidades: ["Empresas Constructoras", "Propietarios Particulares"],
        usos: ["Inicio de cimentaciones", "Cercado de lotes", "Verificación de invasiones de linderos"],
        entregables: ["Puntos de control marcados en campo", "Informe de replanteo", "Acta de entrega de puntos"],
        tiempoEstimado: "1 día (por jornada)"
    },
    {
        slug: "calculo-area",
        titulo: "Rectificación de Áreas y Linderos",
        desc: "Determinación exacta de superficies.",
        descripcionLarga: "Procedimiento técnico para corregir discrepancias entre la realidad física del terreno y lo que figura en las escrituras o Sunarp.",
        precio: "Desde S/ 400",
        img: "https://aceroestudio.com/wp-content/uploads/2023/08/topografia-poligonal-en-calle-inundada-1006x1024.jpg",
        entidades: ["SUNARP", "Poder Judicial (en caso de litigio)", "Notarías"],
        usos: ["Saneamiento físico-legal", "Solución de conflictos con vecinos", "Actualización de autovalúo (HR/PU)"],
        entregables: ["Informe de diagnóstico técnico", "Planos comparativos", "Memoria descriptiva"],
        tiempoEstimado: "3 a 5 días hábiles"
    },
    {
        slug: "levantamiento",
        titulo: "Levantamiento Topográfico con Estación Total",
        desc: "Captura precisa de puntos del terreno.",
        descripcionLarga: "Recolección de datos tridimensionales (X, Y, Z) en campo para representar fielmente la realidad física. Es el punto de partida para cualquier diseño de ingeniería o arquitectura.",
        precio: "Desde S/ 1000",
        img: "https://panoramatopografia.com/wp-content/uploads/2024/08/Topografia.jpg",
        entidades: ["Empresas Constructoras", "Arquitectos", "Gobiernos Regionales"],
        usos: ["Elaboración de expedientes técnicos", "Control de inventarios en canteras", "Monitoreo de estructuras"],
        entregables: ["Base de datos de puntos (CSV/Excel)", "Plano topográfico digital", "Informe de metodología aplicada"],
        tiempoEstimado: "2 a 3 días hábiles"
    },
    {
        slug: "parcelacion",
        titulo: "Parcelaciones de Terrenos Rústicos",
        desc: "División de terrenos en parcelas.",
        descripcionLarga: "Proceso técnico-legal para fraccionar terrenos rurales o eriazos en parcelas de menor tamaño, manteniendo su naturaleza rústica pero facilitando su transferencia.",
        precio: "A consultar",
        img: "https://topografiamuros.com/wp-content/uploads/2023/01/ejemplo-georreferenciacion.jpg",
        entidades: ["Ministerio de Desarrollo Agrario (MIDAGRI)", "SUNARP", "Gobiernos Regionales"],
        usos: ["Venta de parcelas agrícolas", "Proyectos de inversión en casas de campo", "Adjudicaciones por herencia"],
        entregables: ["Plano de parcelación", "Memoria descriptiva de cada unidad", "Certificado de parámetros rústicos"],
        tiempoEstimado: "20 a 45 días (gestión administrativa)"
    },
    {
        slug: "nivelaciones",
        titulo: "Nivelación Geométrica de Precisión",
        desc: "Control de alturas en proyectos.",
        descripcionLarga: "Determinación de desniveles y altitudes con alta precisión para asegurar el correcto flujo de fluidos (desagüe) y la estabilidad de plataformas de cimentación.",
        precio: "Desde S/ 500",
        img: "https://aceroestudio.com/wp-content/uploads/2023/08/nivelacion-geometrica-realizada-en-descampado-en-piura-peru-1024x768.jpg",
        entidades: ["SEDAPAL / Empresas de Agua", "Consorcios de Carreteras", "Proyectos Mineros"],
        usos: ["Instalación de tuberías de saneamiento", "Construcción de pavimentos y veredas", "Control de asentamientos en edificios"],
        entregables: ["Libreta de nivelación electrónica", "Perfil longitudinal", "Informe de cotas (Benchmarks)"],
        tiempoEstimado: "1 a 2 días hábiles"
    },
    {
        slug: "lotizacion",
        titulo: "Trazado y Lotización Urbana",
        desc: "Diseño y marcado de urbanizaciones.",
        descripcionLarga: "Implementación del diseño urbano en el terreno, delimitando manzanas, lotes, vías y áreas de aporte (parques/colegios) según el plano de habilitación aprobado.",
        precio: "A consultar",
        img: "https://thumb.bibliocad.com/images/content/00040000/0000/40008.jpg",
        entidades: ["Municipalidades Distritales y Provinciales", "SUNARP", "Empresas Inmobiliarias"],
        usos: ["Proyectos de habilitación urbana", "Asentamientos humanos (formalización)", "Desarrollo de condominios"],
        entregables: ["Plano de Lotización Georreferenciado", "Estacado físico de manzanas y lotes", "Cuadro de áreas detallado"],
        tiempoEstimado: "Depende de la extensión (Jornadas de campo)"
    }
];